import ToolbarButton from "./toolbarButton/toolbarButton.component";
import { Box } from "@mui/material";
import styles from "./toolbar.module.css"
import { Action } from "../../../types/toolbar";

export interface ToolbarProps {
  actions: Action[];
  noTopPadding?: boolean;
}

export const Toolbar = ({ actions, noTopPadding = false }: ToolbarProps) => {
  return (
    <Box className={`${styles.actions} ${noTopPadding ? styles.noTopPadding : ""}`}>
      {actions.map((action, index) => (
        <ToolbarButton
          key={index}
          icon={action.icon}
          label={action.label}
          onClick={action.onClick}
          color={action.color}
          disabled={action.disabled}
          trailingAdornment={action.trailingAdornment}
        />
      ))}
    </Box>
  );
};
